import { db } from "../firebaseConfig";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { auth } from "../firebaseConfig";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  AuthErrorCodes,
  sendEmailVerification,
  sendPasswordResetEmail,
} from "firebase/auth";
import { TableName } from "../constants/tableName";
import { RoleType } from "../constants/roleType";

export class UsersController {
  static TABLE_NAME = TableName.USERS;

  static get = ({ userId, resolve, reject }) => {
    let errorMessage =
      "Unable to get the users details.\nPlease contact administrator for assistance.";
    getDoc(doc(db, this.TABLE_NAME, userId))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static signUp = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to sign up.\nPlease contact administrator for assistance.";
    createUserWithEmailAndPassword(auth, parameters.email, parameters.password)
      .then((userCredential) => {
        getDoc(doc(db, this.TABLE_NAME, userCredential.user.uid))
          .then((data) => {
            if (!data.exists()) {
              setDoc(doc(db, this.TABLE_NAME, userCredential.user.uid), {
                firstName: parameters.firstName,
                lastName: parameters.lastName,
                email: parameters.email,
                contactNum: parameters.contactNum,
                createdBy: userCredential.user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: userCredential.user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              })
                .then(() => {
                  sendEmailVerification(userCredential.user)
                    .then(() => {
                      resolve(
                        "Please proceed to your email account for varification."
                      );
                    })
                    .catch((error) => {
                      reject(
                        this.errorHandling({
                          errorMessage: "Failed to send verification email:",
                          error: error,
                        })
                      );
                    });
                })
                .catch((error) => {
                  reject(
                    this.errorHandling({
                      errorMessage: errorMessage,
                      error: error,
                    })
                  );
                });
            } else {
              reject("This email has been registered.");
            }
          })
          .catch((error) => {
            reject(
              this.errorHandling({ errorMessage: errorMessage, error: error })
            );
          });
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static login = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to login.\nPlease contact administrator for assistance.";
    signInWithEmailAndPassword(auth, parameters.email, parameters.password)
      .then(async (userCredential) => {
        if (!userCredential.user.emailVerified) {
          reject(
            this.errorHandling({
              errorMessage:
                "Email not verified. Please check your inbox for the verification email.",
              error: null,
            })
          );
        } else {
          const boUsers = await getDoc(
            doc(db, TableName.BOUSERS, userCredential.user.uid)
          );
          let users = null;
          if (!boUsers?.data()) {
            users = await getDoc(
              doc(db, this.TABLE_NAME, userCredential.user.uid)
            );
            if (!users?.data())
              reject(
                this.errorHandling({
                  errorMessage:
                    "User not found.\nPlease provide correct user credential.",
                  error: null,
                })
              );
          }
          localStorage.setItem(
            "user",
            JSON.stringify({
              ...userCredential.user,
              role: boUsers?.data()
                ? boUsers?.data()?.role
                : users?.data()?.role,
            })
          );
          console.debug(userCredential.user);
          resolve(userCredential.user);
        }
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static forgotPassword = ({ email, resolve, reject }) => {
    let errorMessage =
      "Unable to send password reset email.\nPlease contact the administrator for assistance.";
    sendPasswordResetEmail(auth, email)
      .then(() => {
        resolve("Password reset email has been sent. Please check your inbox.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static logout = ({ resolve, reject }) => {
    let errorMessage =
      "Unable to logout.\nPlease contact administrator for assistance.";
    signOut(auth)
      .then(() => {
        localStorage.removeItem("user");
        localStorage.removeItem("colors");
        resolve("Logout successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    if (error === null) return errorMessage;
    switch (error.code) {
      case AuthErrorCodes.EMAIL_EXISTS:
        errorMessage = "This email address is already in use.";
        break;
      case AuthErrorCodes.INVALID_EMAIL:
        errorMessage =
          "Email address provided is invalid.\nPlease use the correct email format or use a different email address.";
        break;
      case AuthErrorCodes.WEAK_PASSWORD:
        errorMessage = "Please provide a stronger password.";
        break;
      case AuthErrorCodes.USER_DISABLED:
        errorMessage =
          "This account has been disabled.\nPlease contact administrator for assistance.";
        break;
      case AuthErrorCodes.USER_DELETED:
      case AuthErrorCodes.INVALID_PASSWORD:
      case AuthErrorCodes.INVALID_LOGIN_CREDENTIALS:
        errorMessage = "Incorrect email or password.";
        break;
      case AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER:
        errorMessage = "Too many attempts.\nPlease try again in a few minutes.";
        break;
      case "auth/missing-email":
        errorMessage = "Missing email address.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
